import Vue from 'vue';
import Router from 'vue-router';
import store from '@/store/index';
/* layout */
const _import = require('./_import_' + process.env.NODE_ENV);
// in development env not use Lazy Loading,because Lazy Loading large page will cause webpack hot update too slow.so only in production use Lazy Loading

/* login */
const Login = _import('login/index');
const LargeScreen = _import('largeScreen/index');
const ScreenChild = _import('largeScreen/screenChild')
const MaterielListChild = _import('largeScreen/materielListChild')
const UserListChild = _import('largeScreen/userListChild')
/* error page */
const Err404 = _import('404');
const VersionText = _import('versionText/index');
/* 查看库存*/
const ViewInventory = _import('viewInventory/index');
const Stock = _import('cabinet/stock');
Vue.use(Router);

/**
 * icon : the icon show in the sidebar
 * hidden : if `hidden:true` will not show in the sidebar
 * redirect : if `redirect:noredirect` will not redirct in the levelbar
 * noDropdown : if `noDropdown:true` will not has submenu in the sidebar
 * meta : `{ role: ['admin'] }`  will control the page role
 **/
export const constantRouterMap = [
    { path: '/login', component: Login, hidden: true },
    { path: '/404', component: Err404, hidden: true },
    { path: '/versionText', component: VersionText, hidden: true },
    { path: '/largeScreen', component: LargeScreen, hidden: true },
    { path: '/viewInventory', component: ViewInventory, hidden: true },
    // Stock
    { path: '/cabinet/stock', component: Stock, hidden: true },
    // largeScreen/screenChild
    { path: '/largeScreen/screenChild', component: ScreenChild, hidden: true },
    // largeScreen/screenChild
    { path: '/largeScreen/materielListChild', component: MaterielListChild, hidden: true },
    // UserListChild
    { path: '/largeScreen/userListChild', component: UserListChild, hidden: true }
]

export default new Router({
  mode: 'history', // 后端支持可开
  base: 'sjg',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRouterMap
});
export const asyncRouterMap = [{ path: '*', redirect: '/404', hidden: true }];



// WEBPACK FOOTER //
// ./src/router/index.js